export enum TreeLevel {
  CHILD = 'child',
  PARENT = 'parent',
  SUBCHILD = 'subchild',
}
